import { MODERATION_ACTION_TYPES, MODERATION_ENTITIES } from './moderationActionTypes';

// Generic list actions
export const fetchModerationList = (entityType, filters = {}) => ({
  type: MODERATION_ACTION_TYPES.FETCH_MODERATION_LIST,
  payload: { entityType, filters }
});

export const fetchModerationListSuccess = (entityType, data) => ({
  type: MODERATION_ACTION_TYPES.FETCH_MODERATION_LIST_SUCCESS,
  payload: { entityType, data }
});

export const fetchModerationListFailure = (entityType, error) => ({
  type: MODERATION_ACTION_TYPES.FETCH_MODERATION_LIST_FAILURE,
  payload: { entityType, error }
});

// User approval specific actions
export const approveUserRequest = (requestId, employeeId, assignmentData) => ({
  type: MODERATION_ACTION_TYPES.APPROVE_USER_REQUEST,
  payload: { requestId, employeeId, assignmentData }
});

export const approveUserSuccess = (requestId, result) => ({
  type: MODERATION_ACTION_TYPES.APPROVE_USER_SUCCESS,
  payload: { requestId, result }
});

export const approveUserFailure = (requestId, error) => ({
  type: MODERATION_ACTION_TYPES.APPROVE_USER_FAILURE,
  payload: { requestId, error }
});

export const fetchEmployeesList = (filters = {}) => ({
  type: MODERATION_ACTION_TYPES.FETCH_EMPLOYEES_LIST,
  payload: { filters }
});

export const fetchEmployeesListSuccess = (requestId, result) => ({
  type: MODERATION_ACTION_TYPES.FETCH_EMPLOYEES_LIST_SUCCESS,
  payload: { requestId, result }
});

export const fetchEmployeesListFailure = (requestId, error) => ({
  type: MODERATION_ACTION_TYPES.FETCH_EMPLOYEES_LIST_FAILURE,
  payload: { requestId, error }
});

export const rejectUserRequest = (requestId, payload) => ({
  type: MODERATION_ACTION_TYPES.REJECT_USER_REQUEST,
  payload: { requestId, payload }
});

export const rejectUserSuccess = (requestId, result) => ({
  type: MODERATION_ACTION_TYPES.REJECT_USER_SUCCESS,
  payload: { requestId, result }
});

export const rejectUserFailure = (requestId, error) => ({
  type: MODERATION_ACTION_TYPES.REJECT_USER_FAILURE,
  payload: { requestId, error }
});

// Employee assignment
export const assignEmployeeToUser = (userId, employeeId) => ({
  type: MODERATION_ACTION_TYPES.ASSIGN_EMPLOYEE_TO_USER,
  payload: { userId, employeeId }
});

// UI actions
export const setActiveModerationTab = (tabName, shouldRefresh = false, dynamicData = {}) => ({
  type: MODERATION_ACTION_TYPES.SET_ACTIVE_MODERATION_TAB,
  payload: { tabName, ...(shouldRefresh && { shouldRefresh: Date.now(), ...dynamicData  }) }
});

export const setModerationFilters = (entityType, filters) => ({
  type: MODERATION_ACTION_TYPES.SET_MODERATION_FILTERS,
  payload: { entityType, filters }
});

export const resetModerationState = (entityType) => ({
  type: MODERATION_ACTION_TYPES.RESET_MODERATION_STATE,
  payload: { entityType }
});

export const updateModerationRow = (entityType, userId, updateData, apiConfig = {}) => ({
  type: MODERATION_ACTION_TYPES.UPDATE_MODERATION_ROW,
  payload: { entityType, userId, updateData, apiConfig }
});

export const updateModerationRowSuccess = (entityType, rowId, result) => ({
  type: MODERATION_ACTION_TYPES.UPDATE_MODERATION_ROW_SUCCESS,
  payload: { entityType, rowId, result }
});

export const updateModerationRowFailure = (entityType, rowId, error) => ({
  type: MODERATION_ACTION_TYPES.UPDATE_MODERATION_ROW_FAILURE,
  payload: { entityType, rowId, error }
});

export const realTimeUpdateRow = (entityType, rowId, updateData) => ({
  type: MODERATION_ACTION_TYPES.REAL_TIME_UPDATE_ROW,
  payload: { entityType, rowId, updateData }
});

export const fetchPendingUsers = (filters) =>
  fetchModerationList(MODERATION_ENTITIES.PENDING_USERS, filters);

export const fetchApprovedUsers = (filters) =>
  fetchModerationList(MODERATION_ENTITIES.APPROVED_USERS, filters);

export const fetchRejectedUsers = (filters) =>
  fetchModerationList(MODERATION_ENTITIES.REJECTED_USERS, filters);
